import { render, staticRenderFns } from "./VPopupResetPassword.vue?vue&type=template&id=4cd61132&scoped=true&"
import script from "./VPopupResetPassword.vue?vue&type=script&lang=ts&"
export * from "./VPopupResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./VPopupResetPassword.vue?vue&type=style&index=0&id=4cd61132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd61132",
  null
  
)

export default component.exports